import React from "react";
import { useSelector } from "react-redux";

// icons
import FileIcon from "@material-ui/icons/InsertDriveFile";
import DeleteIcon from "@material-ui/icons/Cancel";

// material-ui
import makeStyles from "@material-ui/core/styles/makeStyles";
import DialogTitle from "@material-ui/core/DialogTitle";
import Dialog from "@material-ui/core/Dialog";
import Chip from "@material-ui/core/Chip";
import CircularProgress from "@material-ui/core/CircularProgress";

// jazasoft
import { Button, WithReduxForm } from "jazasoft";

import MyFileInput from "../../../components/MyFileInput";

const useStyles = makeStyles(_ => ({
  rootChip: { margin: "0.5em" },
  header: {
    display: "flex",
    justifyContent: "space-between"
  },
  progress: {
    margin: "1em"
  },
  techSheetsViewContainer: {
    display: "flex",
    justifyContent: "flex-start",
    flexWrap: "wrap",
    minHeight: "6em",
    paddingBottom: "1em"
  }
}));

const TechSheetDialog = props => {
  const {
    dialogState,
    techSheets,
    busy,
    hasAccess,
    onDownloadTechSheet,
    onDeleteTechSheet,
    onUploadTechSheets,
    setDialogState
  } = props;
  const classes = useStyles();
  const hasValues = !!useSelector(state => state.form["record-form"]?.values?.techSheets)?.length;

  return (
    <Dialog
      open={(dialogState.action === "techSheets" && dialogState.active) || false}
      onClose={() => setDialogState({})}
      fullWidth
      maxWidth="md">
      <div className={classes.header}>
        <DialogTitle>Tech Sheets</DialogTitle>
        {busy && <CircularProgress size={25} thickness={3} color="secondary" className={classes.progress} />}
      </div>
      <WithReduxForm>
        {({ handleSubmit }) => (
          <div style={{ margin: "1em" }}>
            {/* Existing TechSheets */}

            {!!techSheets?.length && (
              <div className={classes.techSheetsViewContainer}>
                {techSheets?.length > 0 &&
                  techSheets
                    .split(",")
                    .map((filename, idx) => (
                      <Chip
                        key={idx}
                        classes={{ root: classes.rootChip }}
                        icon={<FileIcon />}
                        deleteIcon={hasAccess ? <DeleteIcon /> : <React.Fragment />}
                        label={filename}
                        onClick={() => onDownloadTechSheet(filename)}
                        onDelete={() => hasAccess && onDeleteTechSheet(filename)}
                      />
                    ))}
              </div>
            )}
            {/* Upload new Techsheets */}
            <MyFileInput source="techSheets" multiple label="" xs={12} fullWidth />

            {/* Footer */}
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button onClick={() => setDialogState({})} color="primary">
                Close
              </Button>
              <Button onClick={handleSubmit(onUploadTechSheets)} disabled={!hasValues} color="primary">
                Save
              </Button>
            </div>
          </div>
        )}
      </WithReduxForm>
    </Dialog>
  );
};

export default TechSheetDialog;
